import CheckSmall from '@rover/icons/svg/check-small.svg';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import {
  SELECTION_CHECKBOX_BORDER_WIDTH,
  SELECTION_CHECKBOX_GLYPH_SIZE,
  SELECTION_CHECKBOX_GLYPH_VIEW_BOX,
  SELECTION_CHECKBOX_SIZE,
} from './constants';

type Props = {
  checked: boolean;
};

/**
 * Draws Kibble's `CheckboxField` control without its form plumbing: the tile
 * itself is the checkbox, so this stays out of the way of presses and of
 * screen readers.
 *
 * The unchecked edge is darker than Kibble's `border.primary`, which sits on a
 * known page background rather than on someone's photo.
 */
const GallerySelectionIndicator = ({ checked }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Flex
      testID="gallery-selection-indicator"
      width={SELECTION_CHECKBOX_SIZE}
      height={SELECTION_CHECKBOX_SIZE}
      borderRadius="secondary"
      background={checked ? 'contrast' : 'primary'}
      borderWidth={SELECTION_CHECKBOX_BORDER_WIDTH}
      borderStyle="solid"
      borderColor={`${
        checked
          ? theme.colors.interactive_border.primary_active
          : theme.colors.interactive_border.primary_pressed
      }`}
      alignItems="center"
      justifyContent="center"
      webProps={{ 'aria-hidden': true }}
      rxnProps={{
        importantForAccessibility: 'no-hide-descendants',
        accessibilityElementsHidden: true,
      }}
    >
      {checked && (
        <CheckSmall
          width={SELECTION_CHECKBOX_GLYPH_SIZE}
          height={SELECTION_CHECKBOX_GLYPH_SIZE}
          viewBox={SELECTION_CHECKBOX_GLYPH_VIEW_BOX}
          fill={theme.textColor.primary_inverse}
        />
      )}
    </Flex>
  );
};

export default GallerySelectionIndicator;
